module.exports = __webpack_public_path__ + "static/media/plus-icon.ae0bff9b.svg";